export const formatRelativeTime = (dateString: string | null | undefined): string => {
  if (!dateString) return '—';

  const ms = Date.now() - new Date(dateString).getTime();
  if (Number.isNaN(ms)) return '—';

  const seconds = Math.floor(ms / 1000);
  if (seconds < 60) return `${Math.max(1, seconds)}s ago`;

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.floor(hours / 24);
  return `${days}d ago`;
};
